import { useEffect } from "react";
import { useDispatch } from "react-redux";
import personalProfileActions from "store/personalProfile/personalProfileActions";
import schedulePageActions from "store/schedule/schedulePageActions";
import { CALENDAR_EVENTS_EVENT, CONTRACTORS_EVENT, EQUIPMENT_EVENT, HOLIDAYS_EVENT, PROJECTS_EVENT, SETTINGS_EVENT, SHEET_EVENT, WORKER_EVENT } from "subscriptions/events/events.enum";

const useScheduleSockets = () => {
  const dispatch = useDispatch();

  const socketsConnect = (...args) => {
    dispatch(schedulePageActions.socketConnect(SHEET_EVENT));
    dispatch(schedulePageActions.socketConnect(CALENDAR_EVENTS_EVENT));
    dispatch(schedulePageActions.socketConnect(EQUIPMENT_EVENT));
    dispatch(schedulePageActions.socketConnect(WORKER_EVENT));
    dispatch(schedulePageActions.socketConnect(HOLIDAYS_EVENT));
    dispatch(schedulePageActions.socketConnect(CONTRACTORS_EVENT));
    dispatch(schedulePageActions.socketConnect(PROJECTS_EVENT));
    dispatch(personalProfileActions.socketConnect(SETTINGS_EVENT));
  };
  const socketsDisconnect = (...args) => {
    dispatch(schedulePageActions.socketDisconnect(SHEET_EVENT));
    dispatch(schedulePageActions.socketDisconnect(CALENDAR_EVENTS_EVENT));
    dispatch(schedulePageActions.socketDisconnect(EQUIPMENT_EVENT));
    dispatch(schedulePageActions.socketDisconnect(WORKER_EVENT));
    dispatch(schedulePageActions.socketDisconnect(HOLIDAYS_EVENT));
    dispatch(schedulePageActions.socketDisconnect(CONTRACTORS_EVENT));
    dispatch(schedulePageActions.socketDisconnect(PROJECTS_EVENT));
    dispatch(personalProfileActions.socketDisconnect(SETTINGS_EVENT));
  }

  useEffect(() => {
    socketsConnect();
    return () => {
      socketsDisconnect();
    }
  }, []);
}

export default useScheduleSockets;